module.exports = __webpack_public_path__ + "static/img/coin.ad2f28b5.png";